var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benefit-section-card-wrapper d-flex flex-column align-items-center text-center"},[_c('img',{attrs:{"src":_vm.image,"alt":"image"}}),_c('p',{staticClass:"card-title font-outfit-semi-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"card-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }